// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { mergeWithCss } from "@eisinc/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const sharedTextStyles: TypographyProps = {
    variant: "p",
    size: fontConfig.singleLineSmall.size,
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: ${fontConfig.singleLineSmall.lineHeight};
        margin-bottom: 0;
    `,
};

const headingStyles: TypographyProps = {
    ...sharedTextStyles,
    weight: fontConfig.weight.medium,
    css: css`
        ${sharedTextStyles.css}
        &.horizontal-title {
            display: flex;
            &:after {
                content: ":";
                margin-right: 4px;
            }
        }
    `,
};

const textStyles: TypographyProps = {
    ...sharedTextStyles,
    css: css`
        ${sharedTextStyles.css}
        ${wrapInContainerStyles}
        width: auto;
    `,
};

export const createHorizontalSmallHeadingAndTextStyles = (styles: SmallHeadingAndTextStyles = {}) => {
    return mergeWithCss<SmallHeadingAndTextStyles, SmallHeadingAndTextStyles>(
        {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    @media print {
                        display: flex;
                    }
                `,
            },
            heading: {
                className: "horizontal-title",
                ...headingStyles,
            },
            text: {
                ...textStyles,
            },
        },
        styles,
    );
};

export const createVerticalSmallHeadingAndTextStyles = (styles: SmallHeadingAndTextStyles = {}) => {
    return mergeWithCss<SmallHeadingAndTextStyles, SmallHeadingAndTextStyles>(
        {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    row-gap: 4px;
                    @media print {
                        display: block;
                    }
                `,
            },
            heading: {
                ...headingStyles,
            },
            text: {
                ...textStyles,
            },
        },
        styles,
    );
};
